import React from 'react';
import PropTypes from 'prop-types';

const BackButton = props => {
  const { title, padding, click } = props;

  return (
    <button className="back-button" onClick={click} title="Wróć">
      <span className="icon-right-arrow back-button__icon" />
      <span className={`back-button__title ${padding ? 'back-button__title--padding' : ''} `}>
        {title}
      </span>
    </button>
  );
};

BackButton.propTypes = {
  title: PropTypes.string,
  padding: PropTypes.bool,
  click: PropTypes.func,
};

export default BackButton;
